import { type WorkflowKindAttributes } from './generated/WorkflowKindAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface WorkflowKind extends WorkflowKindAttributes, IColorAttribute {}

@model
@ColorAttribute()
class WorkflowKind extends ApplicationModel {
  // Start auto-generated
  static typename: 'WorkflowKind' = 'WorkflowKind';
  get typename(): 'WorkflowKind' {
    return 'WorkflowKind';
  }

  static internalTypename: 'WorkflowKind' = 'WorkflowKind';
  get internalTypename(): 'WorkflowKind' {
    return 'WorkflowKind';
  }

  static fields = {
    color: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    featureTemplateId: attr({ readable: true }),
    iconName: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    position: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    featureTemplate: attr.belongsTo({
      readable: true,
      typename: 'WorkflowKindTemplate',
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    workflow: attr.belongsTo({ readable: true, typename: 'Workflow' }),
  };
  // End auto-generated
}

export default WorkflowKind;
